import React, { useState } from "react";
import { dishes } from "../data/dishes";
import { ingredients } from "../data/ingredients";
import { useTheme, useDocumentTitle } from "../hooks/useSite";
import { Utensil } from "../illustrations";

export default function IngredientsPage() {
  useTheme(dishes[5]);
  useDocumentTitle("Ingredients");
  const [open, setOpen] = useState(ingredients[0].id);
  const current = ingredients.find((i) => i.id === open);
  return (
    <>
      <section className="ro-education-intro ro-ingredients-intro">
        <div className="ro-container ro-split">
          <div>
            <h1>
              <strong className="ro-italic">{ingredients.length} real</strong>
              <br />
              <span className="ro-outline">ingredients.</span>
            </h1>
            <p className="ro-education-intro__sub">(What goes into a RollOver.)</p>
          </div>
          <Utensil className="ro-ingredients-intro__figure" />
        </div>
      </section>
      <section className="ro-section">
        <div className="ro-container">
          <p className="ro-lead" style={{ maxWidth: 760, marginBottom: 50 }}>
            The fruits, nuts, dairy and spices the café works with, in its own words. Ask the café about allergens before ordering.
          </p>
          <div className="ro-ingredients">
            <div className="ro-ingredients__grid">
              {ingredients.map((i) => (
                <button key={i.id} type="button" className={`ro-ingredient ${i.id === open ? "is-active" : ""}`} aria-pressed={i.id === open} onClick={() => setOpen(i.id)}>
                  <img src={i.image} alt="" loading="lazy" />
                  <span>{i.name}</span>
                </button>
              ))}
            </div>
            <aside className="ro-ingredient-detail" aria-live="polite" key={current.id}>
              <img src={current.image} alt={current.name} />
              <h2 className="ro-italic">{current.name}</h2>
              {current.nutrition && (
                <table className="ro-nutrition">
                  <caption>Nutrition per 100 g</caption>
                  <tbody>
                    {current.nutrition.map((n) => (
                      <tr key={n.name}>
                        <th scope="row">{n.name}</th>
                        <td>{n.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              {current.paragraphs.map((p, n) => (
                <p key={n}>{p}</p>
              ))}
            </aside>
          </div>
        </div>
      </section>
    </>
  );
}
